import formHelpers from "@mixins/helpers/_form";
import errorHandler from "@mixins/responses/_errorHandler";
import vuexKeys from "@mixins/includes/_vuexKeys";
import notifications from "@mixins/includes/_notifications";
import dialogs from "@mixins/includes/_dialogs";
import resources from "@mixins/permissions/_resources";

import MForm from "@modules/forms/m-form";
import MBlockFormButtons from "@modules/blocks/buttons/concrete/m-block-form-buttons";
import MBlockFormFields from "@modules/blocks/form/m-block-form-fields";

let baseForm = {
    $_veeValidate: {
        validator: 'new'
    },
    inheritAttrs: false,
    mixins: [
        formHelpers, notifications, errorHandler, vuexKeys, dialogs, resources
    ],
    components: {
        MForm, MBlockFormFields, MBlockFormButtons
    },
    beforeDestroy() {
        if (this.$refs.form) {
            this.$refs.form.reset();
            this.$validator.reset();
        }
    },
    props: {
        name: {
            type: String,
            required: true
        }
    }
};

export default baseForm;
